export const MESSAGE_TAB_NAMES = {
  SUPPORT: "support",
  CHANNELS: "channels",
  CONVERSATIONS: "conversations"
};
